import { createAction, createReducer } from "@reduxjs/toolkit";
import { FetchReadyState } from "../../types/ReadyState";
export const setConfigurationUnits = createAction("configurationUnitsReducer/setConfigurationUnits", (payload) => ({ payload }));
export const setConfigurationUnitsReadyState = createAction("configurationUnitsReducer/setConfigurationUnitsReadyState", (payload) => ({ payload }));
const initialState = {
    units: {
        units: {},
        unitGroups: {},
        unitDimensions: {},
    },
    readyState: FetchReadyState.Initial,
};
export const configurationUnitsReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setConfigurationUnits, (state, action) => {
        state.units = action.payload;
    })
        .addCase(setConfigurationUnitsReadyState, (state, action) => {
        state.readyState = action.payload;
    });
});
//# sourceMappingURL=configurationUnitsReducer.js.map